// src/pages/IntroPage.jsx
import React from "react";

export default function IntroPage() {
    return (
        <div className="wrap">
            {/* intro 페이지의 main 영역만 구성 (Header/Footer는 App.jsx에서 공통 렌더링) */}
            <div id="main">
                {/* 웹페이지 사용 방법 소개 작성하기 */}
            </div>
        </div>
    );
}
